import { create } from 'zustand'

type SendRecognitionFormStore = {
  isFormDirty: boolean
  setIsFormDirty: (isDirty: boolean) => void
}

export const useSendRecognitionFormStore = create<SendRecognitionFormStore>(set => ({
  isFormDirty: false,
  setIsFormDirty: isDirty => set({ isFormDirty: isDirty }),
}))
